import React, { useEffect, useState } from "react";

// framework and libarry
import { useLazyQuery } from "@apollo/client";
import {
  Tabs,
  Tab,
} from "react-bootstrap";
import * as _ from "lodash";
import useReactRouter from "use-react-router";
import { useLocation } from 'react-router-dom';


//components
import PaginationHelper from "../../helpers/PaginationHelper";
import ReportCredits from "./ReportCredits";
import ClaimCredit from "./claim/ClaimCredit";
import { GET_TRANSACTIONS } from "../../graphql/wallet/query";
import LoadingSpinner from "../../components/LoadingSpinner";
import InvoiceCreditLists from "./invoiceCredit/InvoiceCreditLists";
import { splitDateTime } from "../../helpers";
import HistoryClaims from "./claim/HistoryClaims";

// icons

function InvoiceOrderDatas() {
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const { history, match } = useReactRouter();
  const location = useLocation();


  // useState hook
  const [creditDatas, setCreditDatas] = useState({
    data: [],
    chartDatas: [],
    total: 0,
    credited: 0,
    receivedMoney: 0,
  });
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: "",
    createdAt_lt: "",
  });
  const [paymentMethod, setPaymentMethod] = useState({
    origin: '',
    status: '',
  })
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [isNewFect, setIsNewFect] = useState(false);
  const [fetchOnly, setFetchOnly] = useState(false);
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [remark, setRemark] = useState()

  // use apollo client
  const [
    getAllTransactions,
    { data: transactionData, loading: loadingTransaction },
  ] = useLazyQuery(GET_TRANSACTIONS, { fetchPolicy: "cache-and-network" });


  // useEffect hook
  useEffect(() => {
    if (!_.isEmpty(isNewFect) || !_.isEmpty(paymentMethod) || !_.isEmpty(cdFillter) || !_.isEmpty(_skip) || !_.isEmpty(remark)) {
      fetchTransactions();
    }
  }, [isNewFect, paymentMethod, cdFillter, _skip, remark]);

  useEffect(() => {
    if (transactionData) {
      setCreditDatas({
        data: transactionData?.getAllTransactions?.data,
        total: transactionData?.getAllTransactions?.total,
        credited: transactionData?.getAllTransactions?.reports?.credited,
        receivedMoney: transactionData?.getAllTransactions?.reports?.receivedMoney,
        totalPaidCompleted: transactionData?.getAllTransactions?.reports?.totalPaidCompleted,
        chartDatas: transactionData?.getAllTransactions?.reports?.chartDatas
      });
    }
  }, [transactionData]);

  // function and logic this component
  const fetchTransactions = async () => {
    try {
      let shopId = localStorage.getItem("SHOP");

      if (loadingTransaction) return;
      let _where = {
        shopId: shopId, // "657fbca4741fcb028ebeec3f",
        // status: 'PAYMENT_COMPLETED'
      }

      // is origin or payment method
      if (!_.isEmpty(paymentMethod?.origin)) {
        _where = {
          ..._where,
          origin: paymentMethod?.origin,
        }
      }

      // is remark
      if (!_.isEmpty(remark)) {
        _where = {
          ..._where,
          remark: remark,
        }
      }
      // is status
      if (!_.isEmpty(paymentMethod?.status)) {
        _where = {
          ..._where,
          status: paymentMethod?.status,
        }
      }
      // is current date
      if (!_.isEmpty(cdFillter?.createdAt_gte) || !_.isEmpty(cdFillter?.createdAt_lt)) {
        let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
        let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
        _where = {
          ..._where,
          createdAt_gte: startDateComponents,
          createdAt_lt: endDateComponents,
        }
      }

      await getAllTransactions({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: _limit,
        },
      });
      // setCdFillter({
      //   createdAt_gte: '', createdAt_lt: ''
      // })
    } catch (error) {
      console.log(error);
    }
  };



  // initial props to reportCredit
  const initialPropsReportCredits = {
    creditDatas,
    loadingTransaction,
    setActiveButton,
    activeButton,
    setCdFillter,
    cdFillter,
    setIsCurrentModals,
    isCurrentModals,
  };

  // initial props to cliaimCredit
  const initialPropsClaimcredit = {
    creditDatas,
    loadingTransaction,
    transactionData,
    setIsNewFect,
    _limit,
    _skip,
    Pagination_helper,
    setCdFillter,
    cdFillter,
    activeButton,
    setActiveButton,
    setIsCurrentModals,
    isCurrentModals,
    setPaymentMethod,
    setRemark,
    remark
  };

  const handleSelect = (key) => {
    let pathname = location.pathname;
    let limit = 50;

    if (key === "report-credit" || key === "claim-credit" || key === "history-claim") {
      setFetchOnly(false);
      setActiveButton("thisMonth");

      pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${limit}`);
      pathname = pathname.replace(/(\/page\/)\d+/, "/page/1");
      history.replace(pathname);

    } else if (key === "invoice") {
      setFetchOnly(true);

      pathname = pathname.replace(/(\/limit\/)\d+/, `/limit/${limit}`);
      pathname = pathname.replace(/(\/page\/)\d+/, "/page/1");
      history.replace(pathname);
    }
  };


  return (
    <>
      <div style={{paddingTop: 30}}>
        <div style={{ padding: "0 9px" }}>
          <Tabs
            defaultActiveKey="report-credit"
            id="uncontrolled-tab-example"
            className="mb-3"
            onSelect={handleSelect}
          >
            <Tab eventKey="report-credit" title="ລາຍງານຍອດເງິນ">
              {loadingTransaction ? <LoadingSpinner /> :
                <ReportCredits />
              }
            </Tab>
            <Tab eventKey="claim-credit" title="ເຄມເງິນ">
              <ClaimCredit />
            </Tab>
            <Tab eventKey="invoice" title="ໃບບິນເຄມ">
              {fetchOnly &&
                <InvoiceCreditLists initialProps={initialPropsClaimcredit} />
              }
            </Tab>
            <Tab eventKey="history-claim" title="ປະຫວັດເຄມເງິນ">

              <HistoryClaims />

            </Tab>
          </Tabs>
        </div>
      </div>

    </>
  );
}

export default InvoiceOrderDatas;
